import client from "../client";

export interface GetPendingDepositResponse {
  transaction_id?: number;
  reference_id?: string;
  status?: string;
  amount?: number;
  fee?: number;
  net_amount?: number;
  balance_before?: number;
  balance_after?: number;
  bank_name?: string;
  bank_account?: string;
  bank_account_name?: string;
  notes?: string;
  admin_notes?: string;
  processed_at?: string;
  completed_at?: string;
  created_at?: string;
  // New fields for destination bank details
  dest_bank_name?: string;
  dest_bank_account?: string;
  dest_bank_account_name?: string;
  qr_code?: string;
  rate_in?: number;
}

export default function API(): Promise<GetPendingDepositResponse> {
  return client
    .get(`payment_v2/deposit/pending`)
    .then((response) => response.data);
}
